import { ICReport } from '@fortem-monorepo/web-sdk'

import { CommodityCrudeOilChart } from '@/pages/funds/ic-report//components/primitives/charts/CommodityCrudeOilChart'
import { CommodityNatGasChart } from '@/pages/funds/ic-report//components/primitives/charts/CommodityNatGasChart'

export interface CommodityCurvesProps {
  params: Omit<ICReport.GetICReportDataParams, 'endpoint'>
}

export const CommodityCurves: React.FC<CommodityCurvesProps> = ({ params }) => {
  return (
    <div className="grid grid-cols-2">
      <CommodityCrudeOilChart params={params} />
      <CommodityNatGasChart params={params} />
    </div>
  )
}
